<template>
  <div class="playground">
    <navbar />

    <b-container>
      <b-row class="my-5">
        <b-col sm="8">
          <h2>Playground</h2>
          <b-button class="mr-2" variant="primary" @click="runCode">
            Run
          </b-button>
          <b-button variant="danger" @click="resetWorkspace">Reset</b-button>
          <div class="mt-3" id="blocklyDiv"></div>
        </b-col>

        <b-col sm="4">
          <h2>JavaScript Code</h2>
          <b-button @click="generateCode">Generate</b-button>
          <div class="mt-3" id="js-code">
            {{ code }}
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Blockly from "blockly";
import Interpreter from "js-interpreter";

import Navbar from "@/components/Navbar.vue";
import toolbox from "@/toolbox/playground";

export default {
  name: "playground",

  components: {
    Navbar
  },

  data() {
    return {
      workspace: null,
      code: ""
    };
  },

  mounted() {
    this.injectBlockly();
  },

  methods: {
    injectBlockly() {
      this.workspace = Blockly.inject(document.getElementById("blocklyDiv"), {
        trashcan: true,
        toolbox: toolbox,
        zoom: {
          controls: true,
          startScale: 1.0,
          maxScale: 3,
          minScale: 0.3,
          scaleSpeed: 1.2
        }
      });
    },

    runCode() {
      let workspaceCode = Blockly.JavaScript.workspaceToCode(this.workspace);
      let code = this.appendCode(workspaceCode);
      let myInterpreter = new Interpreter(code, this.getInitApi());
      myInterpreter.run();
    },

    appendCode(code) {
      return code;
    },

    getInitApi() {
      return (interpreter, scope) => {
        let alertWrapper = function(text) {
          return alert(arguments.length ? text.data : "");
        };

        interpreter.setProperty(
          scope,
          "alert",
          interpreter.createNativeFunction(alertWrapper)
        );

        let promptWrapper = function(text) {
          return prompt(text);
        };
        interpreter.setProperty(
          scope,
          "prompt",
          interpreter.createNativeFunction(promptWrapper)
        );
      };
    },

    generateCode() {
      this.code = Blockly.JavaScript.workspaceToCode(this.workspace);
      this.showCode = true;
    },

    resetWorkspace() {
      if (confirm("Are you sure you want to reset playground?")) {
        this.result = {};
        document.getElementById("blocklyDiv").innerHTML = "";
        this.code = "";
        this.injectBlockly();
      }
    }
  }
};
</script>

<style scoped>
#blocklyDiv {
  height: 80vh;
  width: 100%;
}

#js-code {
  border: solid 1px;
  height: 80vh;
  white-space: pre-line;
  overflow: scroll;
}
</style>
